import React from 'react'
import { StandardWidth } from 'services/styles'

export interface IPageContext {
  hasSecondarySidebar: boolean
  secondarySidebarOpen: boolean
  requiredSidebarWidth: StandardWidth
  setSecondarySidebarOpen: (isOpen: boolean) => void
  setRequiredSidebarWidth: (requiredWidth: StandardWidth) => void
  incrementPageSidebarCount: () => void
  decrementPageSidebarCount: () => void
}

const PageContext = React.createContext<IPageContext>({
  hasSecondarySidebar: false,
  secondarySidebarOpen: false,
  requiredSidebarWidth: 'lg',
  setSecondarySidebarOpen: () => { },
  setRequiredSidebarWidth: () => { },
  incrementPageSidebarCount: () => { },
  decrementPageSidebarCount: () => { },
})

export default PageContext
